export default __webpack_public_path__ + "static/media/uae-freezones-and-mainland-business-setup.8ef9c295.png";